export const GET_ADS_URL = 'p/menu/page/v1/widget/';
